import { Injectable } from '@angular/core';
import { CityActions } from '@city/data-access';
import { BonusHistoryApiService, MyAccountActions } from '@my-account/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { AuthActions, UserIdService } from '@spartacus/core';
import { BonusSystemFeatureAvailableService } from '@user/feature';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class BonusHistoryEffects {
  loadBonusHistory$: Observable<MyAccountActions.LoadBonusHistoryFail | MyAccountActions.LoadBonusHistorySuccess> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(MyAccountActions.LOAD_BONUS_HISTORY),
        map((action: MyAccountActions.LoadBonusHistory) => action.payload),
        concatLatestFrom(() => [
          this.bonusSystemFeatureAvailableService.isFeatureAvailable(),
          this.userIdService.getUserId(),
        ]),
        switchMap(([params, isFeatureAvailable, userInfo]) => {
          if (isFeatureAvailable) {
            return this.bonusHistoryApiService.loadBonusHistory(userInfo, params).pipe(
              map((bonuses) => new MyAccountActions.LoadBonusHistorySuccess(bonuses)),
              catchError(() => of(new MyAccountActions.LoadBonusHistoryFail())),
            );
          } else {
            return of(new MyAccountActions.LoadBonusHistoryFail());
          }
        }),
      ),
    );

  loadBonusHistoryOnCityChange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.SET_ACTIVE_BASE_STORE),
      map(() => new MyAccountActions.LoadBonusHistory()),
    ),
  );

  resetBonusHistoryOnLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGOUT),
      switchMap(() =>
        this.bonusSystemFeatureAvailableService.isFeatureAvailable().pipe(
          filter(Boolean),
          map(() => new MyAccountActions.LoadBonusHistoryReset()),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private userIdService: UserIdService,
    private bonusSystemFeatureAvailableService: BonusSystemFeatureAvailableService,
    private bonusHistoryApiService: BonusHistoryApiService,
  ) {}
}
